import React, { useContext } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import type { FlightDropdownOption as SelectOption } from 'components/Flights/types'

import Modal from 'LuxKit/Modal/Modal'
import RadioGroup from 'LuxKit/Radio/RadioGroup'
import FlightDropdownOption from 'components/Flights/FlightSorting/FlightDropdownToggle/FlightDropdownOption'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'

const FixedWidthTextButton = styled(TextButton)`
  min-width: 0;
  flex: 1;
  justify-content: flex-start;

  &.align-end {
    justify-content: flex-end;
  }
`

const TruncatedLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface Props extends Utils.PropsWithDataAttributes {
  options: Array<SelectOption>
  selectedOption: SelectOption
  className?: string
  title: string
  onOptionChange: (option: SelectOption) => void
  name: string
  fixedWidth?: boolean
  alignEnd?: boolean
}

function FareDropdownMobile(props: Props) {
  const { options, selectedOption, onOptionChange, title, name, fixedWidth, alignEnd, ...rest } = props
  const showModal = useContext(ModalContext)

  const onShowFareTypes = () => {
    showModal(
      <Modal title={title}>
        <RadioGroup>
          {options.map((option) => (
            <FlightDropdownOption
              key={option.value}
              defaultChecked={option === selectedOption}
              onChange={onOptionChange}
              option={option}
              name={name}
            />
          ))}
        </RadioGroup>
      </Modal>,
    )
  }

  const label = fixedWidth ? <TruncatedLabel>{selectedOption.label}</TruncatedLabel> : selectedOption.label

  if (fixedWidth) {
    return (
      <FixedWidthTextButton
        {...rest}
        className={clsx(rest.className, { 'align-end': alignEnd })}
        kind="tertiary"
        endIcon={<DropdownChevron />}
        onClick={onShowFareTypes}
      >
        {label}
      </FixedWidthTextButton>
    )
  }

  return (
    <TextButton
      {...rest}
      kind="tertiary"
      endIcon={<DropdownChevron />}
      onClick={onShowFareTypes}
    >
      {label}
    </TextButton>
  )
}

export default FareDropdownMobile
